import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      default: 0
    }
  },
  name: 'OfflineBlindDataOrderEdit',
  data: function data() {
    return {
      title: '',
      form: {
        blindDataOrderId: null,
        blindDataId: null,
        createTime: null,
        dataNum: null,
        memberId: null,
        memberNo: null,
        orderAcount: null,
        orderNo: '',
        orderSts: null,
        payType: null,
        type: this.type
      },
      rules: {
        blindDataOrderId: [{
          required: true,
          message: '请输入标识列',
          trigger: 'blur'
        }],
        blindDataId: [{
          required: true,
          message: '请输入相亲活动id',
          trigger: 'blur'
        }],
        createTime: [{
          required: true,
          message: '请输入订单时间',
          trigger: 'blur'
        }],
        dataNum: [{
          required: true,
          message: '请输入活动次数',
          trigger: 'blur'
        }],
        memberNo: [{
          required: true,
          message: '请输入用户ID',
          trigger: 'blur'
        }],
        orderAcount: [{
          required: true,
          message: '请输入充值金额',
          trigger: 'blur'
        }],
        orderNo: [{
          required: true,
          message: '请输入订单号',
          trigger: 'blur'
        }],
        orderSts: [{
          required: true,
          message: '请输入订单状态 0 未支付 1已支付 2支付失败 3退款',
          trigger: 'blur'
        }],
        payType: [{
          required: true,
          message: '请输入支付类型 0 微信 1支付宝',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请输入相亲活动类型',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.enumList = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.blindDataOrderId = null;
      this.form.blindDataId = null;
      this.form.createTime = null;
      this.form.dataNum = null;
      this.form.memberId = null;
      this.form.orderAcount = null;
      this.form.orderNo = null;
      this.form.orderSts = null;
      this.form.payType = null;
      this.form.type = this.type;
      this.form.memberNo = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.blindDataOrderId = data.blindDataOrderId + '';
      this.form.blindDataId = data.blindDataId + '';
      this.form.createTime = data.createTime + '';
      this.form.dataNum = data.dataNum + '';
      this.form.memberId = data.memberId + '';
      this.form.orderAcount = data.orderAcount + '';
      this.form.orderNo = data.orderNo;
      this.form.orderSts = data.orderSts + '';
      this.form.payType = data.payType + '';
      this.form.type = data.type + '';
    },
    updateApi: function updateApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.UPDATE_BLINDDATAORDER(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    saveApi: function saveApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.GIVE_SAVE_BLINDDATAORDER(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    save: function save() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this4.form.blindDataOrderId != null) {
            _this4.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this4.updateApi();
            }).catch(function () {
              _this4.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this4.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};